// extracted by mini-css-extract-plugin
export var icon = "_8x-3";
export var subtitle = "_8x-2";
export var title = "_8x-1";
export var value = "_8x-0";